import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LoadingSpinner from '../components/LoadingSpinner';
import { fetchBlogPosts } from '../api/blogApi';

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const data = await fetchBlogPosts({ perPage: 10 });
        setPosts(Array.isArray(data) ? data : []);
      } 
        catch (e) { setErr(String(e)); 
      } 
        finally { 
          setLoading(false);
      }
    })();
  }, []);

  if (err) return <p className="text-center py-10 text-red-600">{err}</p>;
  if (loading && !posts?.length) {
    return (
      <p className="text-center py-10">
        <LoadingSpinner children={'Loading.....'} />
      </p>
    );
  }
  if (!posts?.length) return <p className="text-center py-10">No posts yet.</p>;

  return (
    // ⬇️ no top padding here
    <section className="max-w-6xl mx-auto px-6 pt-0 pb-10">
      {/* ⬇️ remove default top margin that was collapsing upward */}
      <h1 className="mt-0 text-3xl font-bold mb-6">Latest Posts</h1>

      <div className="grid gap-6 md:grid-cols-3">
        {posts.map((p) => {
          const cover = p.coverImage?.url;
          return (
            <Link key={p.id} to={`/blog/${p.slug}`} className="block border rounded-2xl overflow-hidden hover:shadow bg-white">
              {cover && <img src={cover} alt="" className="h-28 w-full object-cover" loading="lazy" />}
              <div className="p-5">
                <h2 className="text-xl font-semibold">{p.title}</h2>
                <p className="text-sm opacity-70">{new Date(p.date).toLocaleDateString()}</p>
                <p className="mt-2 line-clamp-3" dangerouslySetInnerHTML={{ __html: p.excerptHtml || "" }} />
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
